(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js');
"use strict";

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

const {
  getBetradarId
} = svs.components.oddset.kambiOffering;
const pmWidgetStyles = svs.components.lbLibs.playmaker.pmWidgetStyles;
const {
  liveDataSubscribe
} = svs.components.oddset.kambiOffering.liveData;
const logger = svs.core.log.getLogger('oddset-kambi:components:playmaker-widget');
var _eventId = new WeakMap();
var _isLive = new WeakMap();
class PlaymakerWidget extends HTMLElement {
  constructor() {
    super();
    _classPrivateFieldInitSpec(this, _eventId, void 0);
    _classPrivateFieldInitSpec(this, _isLive, void 0);
    _defineProperty(this, "updateTime", matchMinute => {
      var _this$spiderWidget, _this$xgLiveWidget, _this$liveWidget;
      if (matchMinute > 120) {
        matchMinute = 120;
      }
      (_this$spiderWidget = this.spiderWidget) === null || _this$spiderWidget === void 0 || _this$spiderWidget.updateTime(matchMinute);
      (_this$xgLiveWidget = this.xgLiveWidget) === null || _this$xgLiveWidget === void 0 || _this$xgLiveWidget.updateTime(matchMinute);
      (_this$liveWidget = this.liveWidget) === null || _this$liveWidget === void 0 || _this$liveWidget.updateTime(matchMinute);
    });
    _defineProperty(this, "onLiveDataUpdate", liveData => {
      if (liveData.matchClock && this.lastMatchMinute !== liveData.matchClock.minute) {
        this.lastMatchMinute = liveData.matchClock.minute;
        this.updateTime(liveData.matchClock.minute);
      }
    });
    _defineProperty(this, "onLiveDataError", error => {
      logger.error('Live data error', error);
    });
    this.spiderWidget = null;
    this.xgLiveWidget = null;
    this.liveWidget = null;
    this.lastMatchMinute = 0;
    this.livedataUnsubscribe = null;
  }
  set eventId(value) {
    _classPrivateFieldSet(_eventId, this, value);
  }
  get eventId() {
    return _classPrivateFieldGet(_eventId, this);
  }
  set isLive(value) {
    _classPrivateFieldSet(_isLive, this, value);
  }
  get isLive() {
    return _classPrivateFieldGet(_isLive, this);
  }
  async connectedCallback() {
    var _liveData;
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const betradarId = await getBetradarId(this.eventId);
    if (!betradarId) {
      return;
    }
    const {
      unsubscribe,
      initialData
    } = liveDataSubscribe(this.eventId, this.onLiveDataUpdate, this.onLiveDataError);
    this.livedataUnsubscribe = unsubscribe;
    let liveData;
    try {
      liveData = await initialData;
    } catch (error) {
      logger.debug('No live data for event');
    }
    shadowRoot.innerHTML = "\n    <div class=\"pm-widget-container\">\n      <div class=\"pm-spider-container live\">\n        <div id=\"pm-live-widget-summary-".concat(betradarId, "\"></div>\n        <div id=\"pm-xg-live-widget-").concat(betradarId, "\"></div>\n        <div id=\"pm-live-widget-spider-").concat(betradarId, "\"></div>\n      </div>\n    </div>\n    ");
    const style = document.createElement('style');
    style.textContent = "\n      ".concat(pmWidgetStyles, "\n      .pm-widget-container {\n        margin-bottom: 30px;\n        padding-bottom: 21px;\n        background: #3b3737;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n        \n      .pm-spider-container {\n        width: 100%;\n        max-width: 366px;\n        display: block;\n        padding: 12px;\n      }");
    shadowRoot.appendChild(style);
    const liveContainer = shadowRoot.querySelector("#pm-live-widget-summary-".concat(betradarId));
    const xgContainer = shadowRoot.querySelector("#pm-xg-live-widget-".concat(betradarId));
    const spiderContainer = shadowRoot.querySelector("#pm-live-widget-spider-".concat(betradarId));
    const pm = window.PM;
    let matchMinute = (_liveData = liveData) === null || _liveData === void 0 || (_liveData = _liveData.matchClock) === null || _liveData === void 0 ? void 0 : _liveData.minute;
    if (Number.isInteger(matchMinute) && matchMinute > 120) {
      matchMinute = 120;
    }
    this.spiderWidget = pm('addLiveWidget', {
      matchId: betradarId,
      gameTime: this.isLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: spiderContainer,
      settings: {
        kpis: [],
        theme: 'dark',
        renderRadar: true,
        autoUpdateScore: true
      }
    });
    this.xgLiveWidget = pm('addXgLiveWidget', {
      matchId: betradarId,
      gameTime: this.isLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: xgContainer,
      settings: {
        theme: 'dark',
        renderLegend: false,
        autoUpdateScore: true
      }
    });
    this.liveWidget = pm('addLiveWidget', {
      matchId: betradarId,
      gameTime: this.isLive && Number.isInteger(matchMinute) ? matchMinute : undefined,
      containerElement: liveContainer,
      settings: {
        theme: 'dark',
        renderSummary: true,
        autoUpdateScore: true
      }
    });
  }
  disconnectedCallback() {
    var _this$livedataUnsubsc;
    (_this$livedataUnsubsc = this.livedataUnsubscribe) === null || _this$livedataUnsubsc === void 0 || _this$livedataUnsubsc.call(this);
  }
}
customElements.define('playmaker-widget', PlaymakerWidget);

 })(window);